import { useState } from "react";
import DistrictSelectorModal from "./DistrictSelector";

export default function AddressSection({
  title,
  loading,
  districtIdField,
  districtNameField,
  address,
  phone,
  formik,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="col-md-6">
      <h5 className="mt-3">{title}</h5>
      <div className="border rounded p-3">
        {loading ? (
          [...Array(3)].map((_, i) => (
            <div key={i} className="mb-2 placeholder-glow">
              <span className="placeholder col-12 py-3 rounded" />
            </div>
          ))
        ) : (
          <>
            <div className="mb-3">
              <button
                type="button"
                className={`form-control text-start ${
                  formik.touched[districtIdField] &&
                  formik.errors[districtIdField]
                    ? "is-invalid"
                    : ""
                }`}
                onClick={() => setShowModal(true)}
              >
                {formik.values[districtNameField] || "-- Байршил сонгох --"}
              </button>
              {formik.touched[districtIdField] &&
                formik.errors[districtIdField] && (
                  <div className="invalid-feedback">
                    {formik.errors[districtIdField]}
                  </div>
                )}
            </div>

            <div className="mb-3">
              <input
                type="text"
                name={address}
                className={`form-control ${
                  formik.touched[address] && formik.errors[address]
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Дэлгэрэнгүй хаяг"
                value={formik.values[address]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched[address] && formik.errors[address] && (
                <div className="invalid-feedback">{formik.errors[address]}</div>
              )}
            </div>

            <div>
              <input
                type="tel"
                inputMode="numeric"
                pattern="\d*"
                name={phone}
                maxLength={8}
                className={`form-control ${
                  formik.touched[phone] && formik.errors[phone]
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Утасны дугаар"
                value={formik.values[phone]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onKeyDown={(e) => {
                  if (
                    !["Backspace", "ArrowLeft", "ArrowRight", "Tab"].includes(
                      e.key
                    ) &&
                    !/^\d$/.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              {formik.touched[phone] && formik.errors[phone] && (
                <div className="invalid-feedback">{formik.errors[phone]}</div>
              )}
            </div>
            <DistrictSelectorModal
              show={showModal}
              onClose={() => setShowModal(false)}
              onSelect={(selected) => {
                formik.setFieldValue(districtIdField, selected.id);
                formik.setFieldValue(districtNameField, selected.name);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
